const STORAGE_KEY = "finprotection-pin-reset";

const defaultState = () => ({
  from: "host",
  isAuthed: false,
  phoneNum: "",
  captchaKey: "",
  resumeSend: false,
});

export const usePinResetFlow = () => {
  const read = () => {
    if (!import.meta.client) return defaultState();
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? { ...defaultState(), ...JSON.parse(raw) } : defaultState();
    } catch {
      return defaultState();
    }
  };

  const write = (patch = {}) => {
    const next = { ...read(), ...patch };
    if (import.meta.client) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    }
    return next;
  };

  const clear = () => {
    if (import.meta.client) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  };

  const start = (from = "host") =>
    write({
      ...defaultState(),
      from: from === "guest" ? "guest" : "host",
    });

  const ensureCaptchaKey = () => {
    const current = read();
    if (current.captchaKey) return current.captchaKey;
    const captchaKey = crypto.randomUUID();
    write({ captchaKey });
    return captchaKey;
  };

  const verifyPath = () => ({
    path: "/join/verify",
    query: { mode: "pin-reset", from: read().from },
  });

  const captchaPath = () => ({
    path: "/join/captcha",
    query: { mode: "pin-reset", from: read().from },
  });

  const resetPinPath = (from = read().from) =>
    from === "guest" ? "/guest/pin?mode=reset" : "/join/pin?mode=reset";

  const unlockPinPath = (from = read().from) =>
    from === "guest" ? "/guest/pin?mode=unlock" : "/join/pin?mode=unlock";

  return {
    read,
    write,
    clear,
    start,
    ensureCaptchaKey,
    verifyPath,
    captchaPath,
    resetPinPath,
    unlockPinPath,
  };
};
